import { FaCheck, FaTimes } from "react-icons/fa";

const ensureUtc = (value) => {
  if (typeof value !== "string") return value;
  const hasTimezone = /[zZ]$|[+-]\d{2}:?\d{2}$/.test(value);
  const hasTime = /\d{2}:\d{2}/.test(value);
  if (!hasTime || hasTimezone) return value;
  const normalized = value.includes(" ") && !value.includes("T")
    ? value.replace(" ", "T")
    : value;
  return `${normalized}Z`;
};

export const formatUtcDate = (value) => formatCreatedAt(ensureUtc(value));

export const formatUtcTime = (value) => formatTime(ensureUtc(value));

export const formatCreatedAt = (createdAt) => {
  const date = new Date(createdAt);
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
    // hour: "numeric",
    // minute: "numeric",
    // second: "numeric",
  };
  return date.toLocaleString("en-US", options);
};

export const formatDataTime = (createdAt) => {
  const date = new Date(createdAt);
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  };
  return date.toLocaleString("en-US", options);
};

export const formatTime = (createdAt) => {
  const date = new Date(createdAt);
  const options = {
    // year: "numeric",
    // month: "short",
    // day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  };
  return date.toLocaleString("en-US", options);
};


export const formatTime2 = (createdAt) => {
  const date = new Date(createdAt);
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: true // This option can be set to true or false based on 12-hour or 24-hour format preference
  };
  return date.toLocaleString("en-US", options);
};



export const formatNumberWithCommas = (number) => {
  const parsedNumber = parseFloat(number);
  if (isNaN(parsedNumber)) {
    return number;
  }
  return parsedNumber.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
};




export const formatNumberWithCommasForUpdate = (number) => {
  if (!number) return '';
  // Remove decimals
  number = number.split('.')[0];
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};




export const formatNumberWithCommas2 = (number) => {
  return number.toString().replace(/[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
};

export const convertValue = (value) => {
  return value === "1" ? (
    <div className="flex justify-center items-center">
      <FaCheck className="text-green-600" />
    </div>
  ) : value === "0" || value === null ? (
    <div className="flex justify-center items-center">
      <FaTimes className="text-red-600" />
    </div>
  ) : (
    value
  );
};
